import React from 'react';
import { useReveal } from '../lib/useReveal';
import { trackEvent } from '../lib/pixel';
const TIERS = [{
  id: 'base',
  badge: null as string | null,
  title: 'MegaPack Integral',
  tagline: 'Aprendé Biodescodificación',
  price: '$19.990',
  includes: ['6 Tomos Profesionales', '6 Bonos Exclusivos', 'Certificado Digital', 'Acceso Inmediato'],
  value: null as string | null,
  cta: 'Quiero el Integral',
  href: 'https://academiaholisticaargentina.com/cart/48895855722746:1',
  accent: 'green'
}, {
  id: 'premium',
  badge: 'MÁS ELEGIDO' as string | null,
  title: 'MegaPack Premium',
  tagline: 'Aprendé + Consultá + Aplicá',
  price: '$29.990',
  includes: ['Todo el MegaPack Integral', 'Vademécum Interactivo', 'Kit Consultor Profesional', 'Cuaderno de Sanación Transgeneracional'],
  value: 'Por solo $10.000 más sumás todo el kit profesional',
  cta: 'Quiero el Premium',
  href: 'https://academiaholisticaargentina.com/cart/48895910347002:1',
  accent: 'gold'
}];
type Tier = (typeof TIERS)[number];
function TierCard({
  tier,
  index
}: {
  tier: Tier;
  index: number;
}) {
  const [ref, vis] = useReveal();
  const isGold = tier.accent === 'gold';
  const isDark = tier.accent === 'dark';
  const cardBg = isGold ? 'bg-[#ffffff]' : isDark ? 'bg-[#2E4F48]' : 'bg-[#ffffff]';
  const cardBorder = isGold ? 'border-2 border-[#C2683D]/80' : isDark ? 'border-2 border-[#1C3B36]' : 'border border-[#2E4F48]/25';
  const shadowClass = isGold ? 'shadow-lg' : isDark ? 'shadow-xl' : 'shadow-md';
  const titleColor = isDark ? 'text-[#ffffff]' : 'text-[#1C3B36]';
  const taglineColor = isDark ? 'text-[#C2683D]' : 'text-[#44574F]';
  const includesLabelColor = isDark ? 'text-[#E8E0D3]/90' : 'text-[#44574F]';
  const itemTextColor = isDark ? 'text-[#ffffff]' : 'text-[#1C3B36]';
  const checkColor = isGold ? 'text-[#C2683D]' : isDark ? 'text-[#C2683D]' : 'text-[#44574F]';
  const priceColor = isDark ? 'text-[#ffffff]' : 'text-[#1C3B36]';
  const arsColor = isDark ? 'text-[#E8E0D3]' : 'text-[#44574F]';
  const dividerColor = isGold ? 'border-[#C2683D]/30' : isDark ? 'border-[#ffffff]/20' : 'border-[#2E4F48]/20';
  const buttonClass = isGold ? 'bg-[#C2683D] hover:bg-[#A8542F] text-[#ffffff] shadow-[0_8px_20px_rgba(194,104,61,0.3)] hover:shadow-[0_12px_25px_rgba(194,104,61,0.4)]' : isDark ? 'bg-[#C2683D] hover:bg-[#A8542F] text-[#ffffff] shadow-[0_8px_20px_rgba(194,104,61,0.3)]' : 'bg-[#1C3B36] hover:bg-[#2E4F48] text-white shadow-md hover:shadow-lg';
  const badgeBg = isGold ? 'bg-[#C2683D]' : isDark ? 'bg-[#C2683D] text-[#ffffff]' : '';
  const emphasis = isGold ? 'ring-2 ring-[#C2683D]/40 sm:scale-[1.04] z-10' : '';
  return <div ref={ref} id={tier.id} className={`reveal relative ${cardBg} ${cardBorder} ${shadowClass} ${emphasis} rounded-2xl p-4 md:p-6 flex flex-col scroll-mt-[180px] md:scroll-mt-8 ${vis ? 'is-visible' : ''}`} style={{
    transitionDelay: `${index * 80}ms`
  }} data-id="element-266" data-mp="3bzwnc16lqvxk">
      {tier.badge && <div className={`absolute -top-3 left-1/2 -translate-x-1/2 ${badgeBg} ${isDark ? '' : 'text-white'} text-[10px] font-bold tracking-[0.2em] px-4 py-1.5 rounded-full whitespace-nowrap shadow-sm`} data-id="element-267" data-mp="36bjh694lpunb">
          {tier.badge}
        </div>}

      <h3 className={`text-base md:text-xl font-serif font-bold ${titleColor} mb-0.5 leading-tight mt-1`} data-id="element-268" data-mp="3g7utv083smia">
        {tier.title}
      </h3>
      <p className={`${taglineColor} text-[11px] sm:text-sm font-semibold mb-2.5 md:mb-4`} data-id="element-269" data-mp="3p2j12vx8oe9q">
        {tier.tagline}
      </p>

      <p className={`${includesLabelColor} text-[9px] md:text-[10px] font-bold uppercase tracking-[0.2em] mb-2`} data-id="element-270" data-mp="3l2sc8xr9w87u">
        Incluye:
      </p>

      <ul className="space-y-1 md:space-y-1.5 mb-3 md:mb-4 flex-grow" data-id="element-271" data-mp="3u25eb5d2huij">
        {tier.includes.map((item, i) => <li key={i} className="flex items-start gap-1.5 md:gap-2" data-id="element-272" data-mp="hxb32olibxre" data-mpi={i}>
            <span className={`${checkColor} flex-shrink-0 mt-0.5 font-bold text-[11px] md:text-xs`} data-id="element-273" data-mp="lz5zbeokzkyb">
              ✓
            </span>
            <span className={`${itemTextColor} text-[12px] md:text-[13px] leading-snug font-medium`} data-id="element-274" data-mp="qsqqonvo5goj">
              {item}
            </span>
          </li>)}
      </ul>

      <div className={`text-center mb-3 md:mb-4 pt-2.5 md:pt-3 border-t ${dividerColor}`} data-id="element-275" data-mp="3v6z0jz427a3u">
        <div className="flex items-baseline gap-1.5 justify-center" data-id="element-276" data-mp="7zwl2kjxr0wz">
          <span className={`text-xl md:text-3xl font-extrabold ${priceColor} leading-none`} data-id="element-277" data-mp="7yljmrdyq591">
            {tier.price}
          </span>
          <span className={`${arsColor} text-xs md:text-sm font-semibold`} data-id="element-278" data-mp="1jfv0r79mcl76">
            ARS
          </span>
        </div>
        {tier.value && <p className="mt-2 inline-block bg-[#C2683D]/10 text-[#C2683D] text-[10px] md:text-[11px] font-bold rounded-full px-3 py-1 leading-tight" data-id="element-279" data-mp="1og9aquus657u">
            {tier.value}
          </p>}
      </div>

      <a href={tier.href} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('InitiateCheckout', {
      content_name: tier.title,
      value: Number(tier.price.replace(/[^0-9]/g, '')),
      currency: 'ARS'
    })} className={`w-full block py-2.5 md:py-3 rounded-xl font-bold text-[11px] md:text-sm tracking-widest uppercase text-center transition-all hover:-translate-y-1 ${buttonClass}`} style={{
      fontFamily: "'Inter', sans-serif"
    }} data-id="element-280" data-mp="33zgmiwctpcye">
        {tier.cta} →
      </a>
    </div>;
}
export function PricingSection() {
  const [ref1, vis1] = useReveal();
  return <section id="pricing" className="bg-[#EFEAE0] py-5 md:py-10 px-4 sm:px-6 border-t border-[#2E4F48]/15" style={{
    scrollMarginTop: '20px'
  }} data-id="element-281" data-mp="edsp5cdh33d7">
      <div className="container mx-auto max-w-4xl" data-id="element-282" data-mp="23vz9yxk708ra">
        <div ref={ref1} className={`reveal text-center mb-5 md:mb-8 ${vis1 ? 'is-visible' : ''}`} data-id="element-283" data-mp="28oacm86bi8nj">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold leading-tight text-[#1C3B36] mb-2" data-id="element-284" data-mp="1u0paohl6ifh7">
            Elegí la versión que{' '}
            <span className="text-[#C2683D] italic" data-id="element-285" data-mp="2mo1p24h6rgzf">mejor se adapte</span> a vos
          </h2>
          <p className="text-[#44574F] text-sm md:text-base max-w-2xl mx-auto leading-relaxed" data-id="element-286" data-mp="2rmmoi1om5wmt">
            Todas las opciones incluyen acceso inmediato y certificado digital.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5 md:gap-6 items-stretch max-w-2xl mx-auto" data-id="element-287" data-mp="2hofbtv1cy0qm">
          {TIERS.map((tier, i) => <TierCard key={tier.id} tier={tier} index={i} data-id="element-288" data-mp="126dicd1j8zrz" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}